import React from 'react'

const About = () => {
  return (
    <div className='about'>
      <h1>About</h1>
      <p>This app made by Yurii Khrobak, for porfolio.</p>
      <a className='github' href='https://github.com/Yurii-Khrobak/react-mobx-note-app'>Github</a>
    </div>
  )
}

export default About
